import { describeDisallowedCharacters, hasInvisibleCharacters } from '~/utils/password'

/**
 * Names, in the reader's language, the characters an instance password may
 * not contain — the "not allowed" line of every form that asks for one (the
 * checkout, the reinstall and the password reset), so the three cannot word
 * the same character three ways.
 */
export function useDisallowedPasswordCharacters() {
  const { t } = useI18n()

  /** Each refused character, named so it can be seen. */
  const describe = (pwd: string): string =>
    describeDisallowedCharacters(pwd, {
      space: t('auth.password.spaceCharacter'),
      invisible: codePoint => t('auth.password.invisibleCharacter', { code: codePoint }),
    })

  /**
   * Where an invisible character came from and what to do about it, or `''`
   * when none was typed. "Caractere invisível (U+200B)" alone answers a
   * question nobody asked: the customer did not type it, they pasted it.
   */
  const pastedHint = (pwd: string): string =>
    hasInvisibleCharacters(pwd) ? t('auth.password.invisibleHint') : ''

  return { describe, pastedHint }
}
